import { Key, StateMachineConfig } from "./types";

export class FSM<T extends Key, Data = any> {
  private readonly _initialState: T;
  private _currentState: T;

  constructor(private config: StateMachineConfig<T, Data>, initialState: T) {
    this._currentState = initialState;
    this._initialState = initialState;
  }

  /**
   * Returns the state with which the FSM was initialized.
   */
  get initialState(): T {
    return this._initialState;
  }

  /**
   * Returns the current state.
   */
  get currentState(): T {
    return this._currentState;
  }

  /**
   * Returns true if the machine can transition from its current state to the given state.
   */
  canTransitionTo(state: T): boolean {
    return -1 < this.config.transitions[this._currentState].to.indexOf(state);
  }
}
